/**
 * BottomTabBar - tab bar kinh mo duoi day cho mobile < 1024px (vung 1 cua app
 * shell o mobile). Cung NAV + RAIL_ICONS + isRailActive voi NavRail (DRY).
 * An/hien hoan toan bang CSS media query (hydration-safe).
 */
import { Link, useLocation } from 'react-router-dom';
import { NAV } from '../header';
import { AccountPopover, type AccountMenuProps } from './AccountPopover';
import { RAIL_ICONS, isRailActive } from './NavRail';

export function BottomTabBar({
  lang,
  isAuthed,
  userName,
  userEmail,
  onLogout,
}: AccountMenuProps) {
  const { pathname } = useLocation();
  return (
    <nav
      className="asklaw-tab-bar"
      data-tab-bar
      aria-label={lang === 'vi' ? 'Điều hướng chính' : 'Main navigation'}
    >
      {NAV.map((n) => {
        const IconCmp = RAIL_ICONS[n.to];
        const active = isRailActive(pathname, n.to);
        return (
          <Link
            key={n.to}
            to={n.to}
            className={
              active
                ? 'asklaw-tab-bar__item asklaw-tab-bar__item--active'
                : 'asklaw-tab-bar__item'
            }
            aria-current={active ? 'page' : undefined}
          >
            {IconCmp && <IconCmp size={20} strokeWidth={1.75} />}
            <span>{lang === 'vi' ? n.label_vi_rail : n.label_en_rail}</span>
          </Link>
        );
      })}
      <AccountPopover
        placement="tab"
        lang={lang}
        isAuthed={isAuthed}
        userName={userName}
        userEmail={userEmail}
        onLogout={onLogout}
      />
    </nav>
  );
}
